import React from 'react';
import { kebabCase, upperCase } from 'lodash';

import Heading from '@react/react-spectrum/Heading';
import Label from '@react/react-spectrum/Label';

import './SmallCard.scss';

export default function SmallCard({
  image,
  icon,
  title,
  description,
  properties,
  tags,
  link,
  links,
  onClick,
  selected,
  disabled
}) {
  const getImage = () => {
    if (typeof image === 'string' && image.startsWith('http')) {
      return <img src={image} />;
    } else {
      return image;
    }
  };

  const Icon = icon;

  return (
    <div
      className={`small-card ${selected ? 'selected' : ''} ${
        disabled ? 'disabled' : ''
      }`}
      onClick={(e) => !disabled && onClick(e)}>
      {image && <span className="image">{getImage()}</span>}
      <span>
        <Heading size="4">
          {icon && <Icon size="S" />}
          {title}
        </Heading>

        <p className="description">{description}</p>

        {Array.isArray(properties) && (
          <div className="properties">
            {properties.map((property) => (
              <div className="property" key={kebabCase(property.name)}>
                <Heading size="5">{property.name}</Heading>
                <p>{property.value}</p>
              </div>
            ))}
          </div>
        )}

        {Array.isArray(tags) && (
          <div className="tags">
            {tags.map((tag) => (
              <Label key={tag}>{upperCase(tag)}</Label>
            ))}
          </div>
        )}

        {link?.url && (
          <a
            href={link.url}
            className="spectrum-Link link"
            target="_blank"
            rel="noopener noreferrer">
            {link.icon}
            {link.label}
          </a>
        )}

        {Array.isArray(links) && (
          <>
            {links.map((item) => (
              <a
                key={item.url}
                href={item.url}
                className="spectrum-Link link"
                target="_blank"
                rel="noopener noreferrer">
                {item.icon}
                {item.label}
              </a>
            ))}
          </>
        )}
      </span>

      {selected && <div className="selection-outline"></div>}
    </div>
  );
}
